var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00008 0.0415039C4.05253 0.0415039 0.041748 4.05229 0.041748 8.99984C0.041748 13.9474 4.05253 17.9582 9.00008 17.9582C13.9477 17.9582 17.9584 13.9474 17.9584 8.99984C17.9584 4.05229 13.9477 0.0415039 9.00008 0.0415039ZM9.83341 5.6665C9.83341 5.20627 9.46033 4.83317 9.00008 4.83317C8.53983 4.83317 8.16675 5.20627 8.16675 5.6665V8.99984C8.16675 9.22084 8.25458 9.43284 8.41083 9.58909L10.0775 11.2558C10.4029 11.5812 10.9306 11.5812 11.256 11.2558C11.5814 10.9303 11.5814 10.4027 11.256 10.0773L9.83341 8.65467V5.6665Z",
    fill: "#172B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClk);
export default __webpack_public_path__ + "static/media/clk.215a2f65c0252d942e3dcaf9ee809f2d.svg";
export { ForwardRef as ReactComponent };